import { ComboBox, InputMaskField, TextInput } from '@components';
import { states } from '@utils';
import { Field, useFormikContext } from 'formik';
import React, { useState } from 'react';
import api from '../../../../common/services/api';

export const Residenciais = () => {
  const [errorCep, setCepError] = useState(null);
  const [loadingCEP, setLoadingCEP] = useState(false);

  const { setFieldValue } = useFormikContext();

  async function fetchAddressByPostalCode(postalCode) {
    const sanitizedPostalCode = postalCode.replace(/\D/g, '');
    if (sanitizedPostalCode) {
      try {
        const response = await api.get('ObterDadosEnderecoCEP', {
          params: {
            cep: sanitizedPostalCode,
          },
        });

        if (response.data.erro) {
          throw new Error('CEP não encontrado');
        }
        return response.data;
      } catch (error) {
        setCepError('CEP inválido. Verifique e tente novamente.');
        return null;
      }
    }
    throw new Error('CEP não encontrado');
  }

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="mb-32 ts-16 fw-bold">Dados de endereço</h3>
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <Field
              name="cep"
              className="mb-3"
              mask="11.111-111"
              inputMode="numeric"
              component={InputMaskField}
              label="CEP"
              onBlur={(e) => {
                setCepError(null);
                setLoadingCEP(true);

                const postalCode = e.target.value.replace(/\D/g, '');

                if (postalCode.length === 8) {
                  setFieldValue('bairro', 'Carregando...');
                  setFieldValue('cidade', 'Carregando...');
                  setFieldValue('estado', 'Carregando...');
                  setFieldValue('numero', 'Carregando...');
                  setFieldValue('complemento', 'Carregando...');
                  fetchAddressByPostalCode(postalCode).then((addressData) => {
                    if (addressData) {
                      setFieldValue('cep', postalCode);
                      setFieldValue('endereco', addressData.logradouro);
                      setFieldValue('bairro', addressData.bairro);
                      setFieldValue('cidade', addressData.localidade);
                      setFieldValue('estado', addressData.uf);
                      setFieldValue('numero', '');
                      setFieldValue('complemento', '');
                      setLoadingCEP(false);
                    } else {
                      setLoadingCEP(false);
                      setFieldValue('bairro', '');
                      setFieldValue('cidade', '');
                      setFieldValue('estado', '');
                      setFieldValue('numero', '');
                      setFieldValue('complemento', '');
                    }
                  });
                }
              }}
            />
            {errorCep && (
              <div className="validation-error mb-2" style={{ marginTop: -20 }}>
                {' '}
                {errorCep}
              </div>
            )}

            <Field
              name="endereco"
              disabled={loadingCEP}
              className="mb-3"
              component={TextInput}
              label="Logradouro"
            />
            <Field
              name="numero"
              disabled={loadingCEP}
              className="mb-3"
              type="number"
              component={TextInput}
              label="Número"
            />
            <Field
              name="complemento"
              className="mb-3"
              component={TextInput}
              label="Complemento"
            />
          </div>
          <div className="col-md-12 col-lg-6">
            <Field
              name="bairro"
              disabled={loadingCEP}
              className="mb-3"
              component={TextInput}
              label="Bairro"
            />
            <Field
              name="cidade"
              disabled={loadingCEP}
              className="mb-3"
              component={TextInput}
              label="Cidade"
            />
            <Field
              name="estado"
              disabled={loadingCEP}
              className="mb-3"
              component={ComboBox}
              label="Estado"
              options={states.map((s) => {
                return { value: s.sigla, label: s.estado };
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
